import * as PIXI from "pixi.js";
import MyApplication from "../pixi/MyApplication";
import AssetsManager from "../pixi/AssetsManager";

/**
 * SoundButtonクラス
 */
class SoundButton extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //フラグ
  private _isMute: boolean;

  //ムービークリップ
  private _mc: PIXI.AnimatedSprite;

  // ---------------------------------------------------------------------------------------------------------
  // --	SoundButton
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //ムービークリップ配置
    this._mc = AssetsManager.instance.createMovieClip([
      AssetsManager.instance.getTexture("sound_btn1.png", false),
      AssetsManager.instance.getTexture("sound_btn2.png", false),
    ]);
    this._mc.scale.set(4);
    this.addChild(this._mc);

    //位置
    this.x = 20;
    this.y = 20;

    //重ね順
    this.zIndex = 99;

    //ボタンアクション
    this.interactive = true;
    this.cursor = "pointer";
    this.on("pointerdown", this.onTap.bind(this));
  }

  /**
   * 初期化
   */
  init(): void {
    this._isMute = AssetsManager.instance.isMute;
    this.updateView();
  }

  /**
   * タップされた
   */
  onTap(): void {
    //フラグ反転
    this._isMute = !this._isMute;

    //ミュートor再生
    AssetsManager.instance.soundMute(this._isMute);

    //VIEWのアップデート
    this.updateView();
  }

  /**
   * VIEWのアップデート
   */
  updateView(): void {
    if (this._isMute) {
      this._mc.gotoAndStop(1);
    } else {
      this._mc.gotoAndStop(0);
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default SoundButton;
